<template>
  <!--== Start Footer Area Wrapper ==-->
  <footer class="footer-area">
    <div id="contact-us" class="container">
      <div class="row">
        <div class="col-sm-6 col-md-5 col-lg-4 col-xl-4">
          <div class="widget-item">
            <div class="about-widget">
              <a class="footer-logo d-flex justify-content-center" href="javascript:void(0)">
                <img src="../../assets/img/logo-daring.png" height="75" alt="Logo" />
              </a>
              <p class="mb-0">
                Jika ada keperluan, silahkan hubungi kami melalui:
              </p>
              <ul class="widget-contact-info" style="padding-left: 0px;">
                <li class="info-address">
                  <i class="icofont-location-pin"></i>Jl. Jend. Ahmad Yani no. 136 Kode Pos 46213 Ciamis
                </li>
                <li class="info-mail">
                  <i class="icofont-email"></i
                  ><a href="mailto://binapandumandiri@gmail.com"
                    >binapandumandiri@gmail.com</a
                  >
                </li>
                <li class="info-phone">
                  <i class="icofont-ui-call"></i
                  >
                  <a href="tel://081320243104">+62 813-2024-3104</a>
                </li>
                <li class="info-phone">
                  <i class="icofont-ui-call"></i
                  ><a href="tel://082240598842">+62 822-4059-8842</a>
                </li>
                <li class="info-phone">
                  <i class="icofont-ui-call"></i
                  ><a href="tel://082320221550">+62 823-2022-1550</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-5 col-lg-4 col-xl-4">
          <div class="widget-item">
            <h4 class="widget-title line-bottom">Program Layanan</h4>
            <nav class="widget-posts">
              <ul class="posts-item">
                <li>
                  <a href="javascript:void(0);" @click="showModalLogin"
                    ><i class="icon icofont-rounded-double-right"></i>Paket A</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" @click="showModalLogin"
                    ><i class="icon icofont-rounded-double-right"></i
                    >Paket B</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" @click="showModalLogin"
                    ><i class="icon icofont-rounded-double-right"></i>Paket C</a
                  >
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div class="col-sm-6 col-md-5 col-lg-4 col-xl-4">
          <div class="widget-item">
            <h4 class="widget-title line-bottom">Ikuti Kami</h4>
            <div class="about-widget">
              <ul class="widget-contact-info">
                <li class="info-phone">
                  <i style="width:37px" class="icofont-facebook"></i
                  ><a target="_blank" href="https://www.facebook.com/pkbm.binapandumandiri.96">PKBM Bina Pandu Mandiri</a>
                </li>
                <li class="info-phone">
                  <i class="icofont-instagram"></i
                  ><a target="_blank" href="https://www.instagram.com/pkbm_bina_pandu_mandiri/?igshid=18bmygdqc418f">PKBM Bina Pandu Mandiri</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <b-modal
        ref="login-modal"
        class="login-model"
        size="md"
        hide-footer
        hide-header
        no-close-on-backdrop
      >
        <login-form></login-form>
      </b-modal>
    </div>
  </footer>
  <!--== End Footer Area Wrapper ==-->
</template>
<script>
	import LoginForm from "../../components/Main/LoginForm";
  import { EventBus } from '@/eventBus.js'
  export default {
    components: {
      LoginForm
    },
    data() {
      return {
        year: new Date().getFullYear()
      }
    },
    methods: {
      showModalLogin() {
        this.$refs['login-modal'].show()
      },
      hideModalLogin() {
        this.$refs['login-modal'].hide()
      },
    },
    created () {
      EventBus.$on('hideModalLogin', (val) => {
        if (val) {
          this.hideModalLogin()
        }
      })
      EventBus.$on('scrollToContact', (val) => {
        if (val) {
          this.$scrollTo('#contact-us')
        }
      })
    },
  };
</script>
<style>
</style>
